"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../utils/core"));

var _jquery = _interopRequireDefault(require("../utils/jquery.webf"));

require("./shortcut");

require("./alert");

var _jquery2 = _interopRequireDefault(require("jquery"));

/**
 * options:
 *  - msgBeforeUnload:  (string) Message affiché dans un alert natif quand l'utilisateur quitte la page après avoir
 *                      modifié le formulaire mais sans avoir enregistré.
 *  - preventDblClick:  (bool) Protection contre les double clic
 *  - shortcut:         (bool) Gestion du Ctrl + S
 *  - delay:            (integer) Nb. de ms à patienter avant de calculer l'état initial du formulaire
 *  - shortcutOnForm:   (bool) Si true, déclenche le shortcut sur le form, sinon, sur document
 *  - exclude:          (string[]) Exclure de la validation les champs correspondant au sélecteur ou à l'attribut name
 *  - onSubmit:         (function($form, ev)) Callback appelée sur le submit du formulaire
 */
(0, _jquery["default"])('submit', {
  options: {
    msgBeforeUnload: false,
    preventDblClick: true,
    shortcut: false,
    delay: 500,
    shortcutOnForm: false,
    exclude: [],
    onBeforeSubmit: _core["default"].noop,
    onSubmit: _core["default"].noop,
    onError: _core["default"].noop
  },
  _create: function _create() {
    var msgBeforeUnload = this.option('onBeforeUnload'),
        preventDblClick = this.option('preventDblClick'),
        shortcut = this.option('shortcut'),
        delay = this.option('delay'),
        onSubmit = this.option('onSubmit'),
        onBeforeSubmit = this.option('onBeforeSubmit');
    var self = this,
        $form = this.e,
        initialState;
    $form.attr('novalidate', 'novalidate');

    if (msgBeforeUnload) {
      var getState = function getState() {
        var vals = [];
        $form.find('input, select, textarea').each(function () {
          if (!_core["default"].inArray((0, _jquery2["default"])(this).prop('type'), 'submit button image'.split(' '))) {
            var value = (0, _jquery2["default"])(this).val();

            if (_core["default"].inArray((0, _jquery2["default"])(this).prop('type'), 'checkbox'.split(' '))) {
              value = (0, _jquery2["default"])(this).prop('checked') ? 1 : 0;
            }

            if (_core["default"].isArray(value)) {
              value = value.join(',');
            }

            vals.push(value);
          }
        });
        return hex_md5(vals.join(''));
      };

      window.onbeforeunload = function (e) {
        if (!initialState || initialState == getState()) {
          return;
        }

        var ev = e || window.event,
            msg = msgBeforeUnload === true ? "Vous devriez enregistrer votre travail avant de quitter la page" : msgBeforeUnload;

        if (ev) {
          ev.returnValue = msg;
        }

        return msg;
      };

      _core["default"].setTimeout(function () {
        initialState = getState();
      }, delay);
    }

    $form.data('submitted', false);
    $form.on('submit', function (ev) {
      var valid = true,
          hasError = false;
      $form.find(':input').each(function () {
        var readonly = false;

        if ((0, _jquery2["default"])(this).attr('readonly')) {
          readonly = true;
          (0, _jquery2["default"])(this).attr('readonly', false);
        }

        if (_core["default"].inArray((0, _jquery2["default"])(this).attr('name'), self.option('exclude'))) {
          return true;
        }

        var _continue = false;

        _core["default"].each(self.option('exclude'), function (i, selector) {
          if ((0, _jquery2["default"])(this).filter(selector)[0]) {
            _continue = true;
          }
        }, this);

        if (_continue) return true;

        if (!hasError && this.checkValidity && !this.checkValidity()) {
          valid = false;
          (0, _jquery2["default"])(this).closest('.form-group').addClass('has-error');
          var label = (0, _jquery2["default"])(this).closest('.form-group').find('label').first().text();

          if (!label.length) {
            var $label = $form.find("label[for='" + (0, _jquery2["default"])(this).attr('id') + "']");

            if ((0, _jquery2["default"])(this).attr('id') && $label[0]) {
              label = $label.text();
            } else if ((0, _jquery2["default"])(this).data('labelError')) {
              label = (0, _jquery2["default"])(this).data('labelError');
            } else {
              label = (0, _jquery2["default"])(this).attr('name');
            }
          }

          if (self._call(self.option('onError'), (0, _jquery2["default"])(this)) !== false) {
            (0, _jquery2["default"])('<div><b>' + label + ' : </b>' + this.validationMessage + '</div>').webfAlert({
              alertType: 'danger',
              placement: 'center',
              autoClose: true,
              delayClose: 8000,
              durationClose: 1000
            });
          }

          hasError = true;
        }

        if (readonly) {
          (0, _jquery2["default"])(this).attr('readonly', true);
        }
      });

      if (!valid) {
        ev.preventDefault();
        return false;
      }

      if (self._call(onBeforeSubmit, $form, ev) === false) {
        ev.preventDefault();
        return false;
      }

      if (msgBeforeUnload) {
        initialState = getState();
      }

      if (self._call(onSubmit, $form, ev) === false) {
        ev.preventDefault();
        return false;
      } else {
        if (preventDblClick) {
          if (!$form.data('submitted')) {
            $form.data('submitted', true);
          } else {
            ev.preventDefault();
            return false;
          }
        }
      }

      return true;
    });

    if (shortcut) {
      (0, _jquery2["default"])(this.option('shortcutOnForm') ? this.e : window.document).webfShortcut({
        keys: shortcut === true ? 'Mod + S' : shortcut,
        fn: function fn() {
          $form.trigger('submit');
          return false;
        }
      });
    }
  }
});
var hexcase = 0;

function hex_md5(a) {
  return rstr2hex(rstr_md5(str2rstr_utf8(a)));
}

function hex_hmac_md5(a, b) {
  return rstr2hex(rstr_hmac_md5(str2rstr_utf8(a), str2rstr_utf8(b)));
}

function md5_vm_test() {
  return hex_md5("abc").toLowerCase() == "900150983cd24fb0d6963f7d28e17f72";
}

function rstr_md5(a) {
  return binl2rstr(binl_md5(rstr2binl(a), a.length * 8));
}

function rstr_hmac_md5(c, f) {
  var e = rstr2binl(c);

  if (e.length > 16) {
    e = binl_md5(e, c.length * 8);
  }

  var a = Array(16),
      d = Array(16);

  for (var b = 0; b < 16; b++) {
    a[b] = e[b] ^ 909522486;
    d[b] = e[b] ^ 1549556828;
  }

  var g = binl_md5(a.concat(rstr2binl(f)), 512 + f.length * 8);
  return binl2rstr(binl_md5(d.concat(g), 512 + 128));
}

function rstr2hex(c) {
  try {
    hexcase;
  } catch (g) {
    hexcase = 0;
  }

  var f = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  var b = "";
  var a;

  for (var d = 0; d < c.length; d++) {
    a = c.charCodeAt(d);
    b += f.charAt(a >>> 4 & 15) + f.charAt(a & 15);
  }

  return b;
}

function str2rstr_utf8(c) {
  var b = "";
  var d = -1;
  var a, e;

  while (++d < c.length) {
    a = c.charCodeAt(d);
    e = d + 1 < c.length ? c.charCodeAt(d + 1) : 0;

    if (55296 <= a && a <= 56319 && 56320 <= e && e <= 57343) {
      a = 65536 + ((a & 1023) << 10) + (e & 1023);
      d++;
    }

    if (a <= 127) {
      b += String.fromCharCode(a);
    } else {
      if (a <= 2047) {
        b += String.fromCharCode(192 | a >>> 6 & 31, 128 | a & 63);
      } else {
        if (a <= 65535) {
          b += String.fromCharCode(224 | a >>> 12 & 15, 128 | a >>> 6 & 63, 128 | a & 63);
        } else {
          if (a <= 2097151) {
            b += String.fromCharCode(240 | a >>> 18 & 7, 128 | a >>> 12 & 63, 128 | a >>> 6 & 63, 128 | a & 63);
          }
        }
      }
    }
  }

  return b;
}

function rstr2binl(b) {
  var a = Array(b.length >> 2);

  for (var c = 0; c < a.length; c++) {
    a[c] = 0;
  }

  for (var c = 0; c < b.length * 8; c += 8) {
    a[c >> 5] |= (b.charCodeAt(c / 8) & 255) << c % 32;
  }

  return a;
}

function binl2rstr(b) {
  var a = "";

  for (var c = 0; c < b.length * 32; c += 8) {
    a += String.fromCharCode(b[c >> 5] >>> c % 32 & 255);
  }

  return a;
}

function binl_md5(p, k) {
  p[k >> 5] |= 128 << k % 32;
  p[(k + 64 >>> 9 << 4) + 14] = k;
  var o = 1732584193;
  var n = -271733879;
  var m = -1732584194;
  var l = 271733878;

  for (var g = 0; g < p.length; g += 16) {
    var j = o;
    var h = n;
    var f = m;
    var e = l;
    o = md5_ff(o, n, m, l, p[g + 0], 7, -680876936);
    l = md5_ff(l, o, n, m, p[g + 1], 12, -389564586);
    m = md5_ff(m, l, o, n, p[g + 2], 17, 606105819);
    n = md5_ff(n, m, l, o, p[g + 3], 22, -1044525330);
    o = md5_ff(o, n, m, l, p[g + 4], 7, -176418897);
    l = md5_ff(l, o, n, m, p[g + 5], 12, 1200080426);
    m = md5_ff(m, l, o, n, p[g + 6], 17, -1473231341);
    n = md5_ff(n, m, l, o, p[g + 7], 22, -45705983);
    o = md5_ff(o, n, m, l, p[g + 8], 7, 1770035416);
    l = md5_ff(l, o, n, m, p[g + 9], 12, -1958414417);
    m = md5_ff(m, l, o, n, p[g + 10], 17, -42063);
    n = md5_ff(n, m, l, o, p[g + 11], 22, -1990404162);
    o = md5_ff(o, n, m, l, p[g + 12], 7, 1804603682);
    l = md5_ff(l, o, n, m, p[g + 13], 12, -40341101);
    m = md5_ff(m, l, o, n, p[g + 14], 17, -1502002290);
    n = md5_ff(n, m, l, o, p[g + 15], 22, 1236535329);
    o = md5_gg(o, n, m, l, p[g + 1], 5, -165796510);
    l = md5_gg(l, o, n, m, p[g + 6], 9, -1069501632);
    m = md5_gg(m, l, o, n, p[g + 11], 14, 643717713);
    n = md5_gg(n, m, l, o, p[g + 0], 20, -373897302);
    o = md5_gg(o, n, m, l, p[g + 5], 5, -701558691);
    l = md5_gg(l, o, n, m, p[g + 10], 9, 38016083);
    m = md5_gg(m, l, o, n, p[g + 15], 14, -660478335);
    n = md5_gg(n, m, l, o, p[g + 4], 20, -405537848);
    o = md5_gg(o, n, m, l, p[g + 9], 5, 568446438);
    l = md5_gg(l, o, n, m, p[g + 14], 9, -1019803690);
    m = md5_gg(m, l, o, n, p[g + 3], 14, -187363961);
    n = md5_gg(n, m, l, o, p[g + 8], 20, 1163531501);
    o = md5_gg(o, n, m, l, p[g + 13], 5, -1444681467);
    l = md5_gg(l, o, n, m, p[g + 2], 9, -51403784);
    m = md5_gg(m, l, o, n, p[g + 7], 14, 1735328473);
    n = md5_gg(n, m, l, o, p[g + 12], 20, -1926607734);
    o = md5_hh(o, n, m, l, p[g + 5], 4, -378558);
    l = md5_hh(l, o, n, m, p[g + 8], 11, -2022574463);
    m = md5_hh(m, l, o, n, p[g + 11], 16, 1839030562);
    n = md5_hh(n, m, l, o, p[g + 14], 23, -35309556);
    o = md5_hh(o, n, m, l, p[g + 1], 4, -1530992060);
    l = md5_hh(l, o, n, m, p[g + 4], 11, 1272893353);
    m = md5_hh(m, l, o, n, p[g + 7], 16, -155497632);
    n = md5_hh(n, m, l, o, p[g + 10], 23, -1094730640);
    o = md5_hh(o, n, m, l, p[g + 13], 4, 681279174);
    l = md5_hh(l, o, n, m, p[g + 0], 11, -358537222);
    m = md5_hh(m, l, o, n, p[g + 3], 16, -722521979);
    n = md5_hh(n, m, l, o, p[g + 6], 23, 76029189);
    o = md5_hh(o, n, m, l, p[g + 9], 4, -640364487);
    l = md5_hh(l, o, n, m, p[g + 12], 11, -421815835);
    m = md5_hh(m, l, o, n, p[g + 15], 16, 530742520);
    n = md5_hh(n, m, l, o, p[g + 2], 23, -995338651);
    o = md5_ii(o, n, m, l, p[g + 0], 6, -198630844);
    l = md5_ii(l, o, n, m, p[g + 7], 10, 1126891415);
    m = md5_ii(m, l, o, n, p[g + 14], 15, -1416354905);
    n = md5_ii(n, m, l, o, p[g + 5], 21, -57434055);
    o = md5_ii(o, n, m, l, p[g + 12], 6, 1700485571);
    l = md5_ii(l, o, n, m, p[g + 3], 10, -1894986606);
    m = md5_ii(m, l, o, n, p[g + 10], 15, -1051523);
    n = md5_ii(n, m, l, o, p[g + 1], 21, -2054922799);
    o = md5_ii(o, n, m, l, p[g + 8], 6, 1873313359);
    l = md5_ii(l, o, n, m, p[g + 15], 10, -30611744);
    m = md5_ii(m, l, o, n, p[g + 6], 15, -1560198380);
    n = md5_ii(n, m, l, o, p[g + 13], 21, 1309151649);
    o = md5_ii(o, n, m, l, p[g + 4], 6, -145523070);
    l = md5_ii(l, o, n, m, p[g + 11], 10, -1120210379);
    m = md5_ii(m, l, o, n, p[g + 2], 15, 718787259);
    n = md5_ii(n, m, l, o, p[g + 9], 21, -343485551);
    o = safe_add(o, j);
    n = safe_add(n, h);
    m = safe_add(m, f);
    l = safe_add(l, e);
  }

  return Array(o, n, m, l);
}

function md5_cmn(h, e, d, c, g, f) {
  return safe_add(bit_rol(safe_add(safe_add(e, h), safe_add(c, f)), g), d);
}

function md5_ff(g, f, k, j, e, i, h) {
  return md5_cmn(f & k | ~f & j, g, f, e, i, h);
}

function md5_gg(g, f, k, j, e, i, h) {
  return md5_cmn(f & j | k & ~j, g, f, e, i, h);
}

function md5_hh(g, f, k, j, e, i, h) {
  return md5_cmn(f ^ k ^ j, g, f, e, i, h);
}

function md5_ii(g, f, k, j, e, i, h) {
  return md5_cmn(k ^ (f | ~j), g, f, e, i, h);
}

function safe_add(a, d) {
  var c = (a & 65535) + (d & 65535);
  var b = (a >> 16) + (d >> 16) + (c >> 16);
  return b << 16 | c & 65535;
}

function bit_rol(a, b) {
  return a << b | a >>> 32 - b;
}